import { GET_DROP_EVENTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { adminKey } from 'root/src/shared/constants/keys'
import { DROP_ADMIN_LIST_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default ({ value }) => async dispatch => dispatch(apiRequest(
	GET_DROP_EVENTS,
	{ value, section: adminKey, pageItemLength: 20 },
	true,
	DROP_ADMIN_LIST_MODULE_ID,
))
